export const COMPANY = {
    name: "Alpen Reinigung",
    legalName: "Reinigungsservice Faisal Safi",
    owner: "Faisal Safi",
    tagline: "Sauberkeit. Qualität. Zuverlässigkeit.",
    address: {
        street: "Schusterbergweg 72",
        city: "6020 Innsbruck",
        country: "Österreich",
    },
    phone: "+43 676 7092658",
    phoneTel: "+436767092658",
    email: "info@alpen-reinigung.at",
    atu: "ATU 81700830",
    stNr: "81302/8198",
    dgNr: "102440692",
    logo: "https://customer-assets.emergentagent.com/job_9a34e701-26e8-4170-b44c-e47177d41228/artifacts/l5cp30vr_EF15EC7F-D5BD-43A8-B262-226014982094.png",
};

export const SERVICES = [
    {
        slug: "gebaeudereinigung",
        title: "Gebäudereinigung",
        h1: "Gebäudereinigung Innsbruck & Tirol",
        short: "Komplettpflege für Büros, Wohnanlagen und Gewerbeobjekte.",
        intro:
            "Saubere Treppenhäuser, gepflegte Eingangsbereiche und blitzblanke Sanitäranlagen sind die Visitenkarte jedes Gebäudes. Alpen Reinigung übernimmt die professionelle Gebäudereinigung in Innsbruck und ganz Tirol – diskret, zuverlässig und mit fester Ansprechperson.",
        details: [
            "Treppenhäuser, Gänge, Eingänge",
            "Allgemeinflächen & Sanitäranlagen",
            "Aufzüge, Türen, Beschläge",
        ],
        bullets: [
            "Wohnanlagen, Mehrparteienhäuser, Hausverwaltungen",
            "Bürogebäude, Praxen, Kanzleien",
            "Gewerbe-, Handels- und Industrieobjekte",
            "Sonderreinigungen nach Bedarf integrierbar",
        ],
        seo_title:
            "Gebäudereinigung Innsbruck & Tirol – Alpen Reinigung",
        seo_description:
            "Professionelle Gebäudereinigung in Innsbruck und Tirol: Treppenhäuser, Allgemeinflächen, Sanitär. Für Hausverwaltungen, Büros und Gewerbe. ☎ +43 676 7092658.",
        keywords: [
            "Gebäudereinigung Innsbruck",
            "Gebäudereinigung Tirol",
            "Treppenhausreinigung Innsbruck",
            "Hausreinigung Innsbruck",
        ],
        icon: "Building2",
        image:
            "https://images.pexels.com/photos/6195120/pexels-photo-6195120.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=720&w=1100",
    },
    {
        slug: "fassadenreinigung",
        title: "Fassadenreinigung",
        h1: "Fassadenreinigung Innsbruck & Tirol",
        short: "Schonende Reinigung mit Niederdruck-Verfahren.",
        intro:
            "Eine saubere Fassade verbessert nicht nur den ersten Eindruck Ihres Gebäudes – sie schützt auch die Bausubstanz langfristig vor Algen, Moos und Verschmutzung. Wir reinigen Putz-, Klinker- und Glasfassaden in Innsbruck und Tirol schonend und materialgerecht.",
        details: [
            "Putz-, Klinker- und Glasfassaden",
            "Algen-, Moos- und Schmutzentfernung",
            "Mit Hubarbeitsbühne wo nötig",
        ],
        bullets: [
            "Niederdruck- und Heißwasserverfahren – materialschonend",
            "Mit Hubarbeitsbühne, Steiger oder Industriekletterer",
            "Auf Wunsch mit Imprägnierung gegen erneute Verschmutzung",
            "Für Wohn-, Büro- und Gewerbegebäude in ganz Tirol",
        ],
        seo_title:
            "Fassadenreinigung Innsbruck & Tirol – Alpen Reinigung",
        seo_description:
            "Schonende Fassadenreinigung in Innsbruck und Tirol – Putz, Klinker, Glasfassade. Algen-, Moos- und Schmutzentfernung mit Hubarbeitsbühne. ☎ +43 676 7092658.",
        keywords: [
            "Fassadenreinigung Innsbruck",
            "Fassadenreinigung Tirol",
            "Algen entfernen Fassade Tirol",
            "Glasfassade reinigen Innsbruck",
        ],
        icon: "Layers",
        image:
            "https://images.pexels.com/photos/2098624/pexels-photo-2098624.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=720&w=1100",
    },
    {
        slug: "fensterreinigung",
        title: "Fensterreinigung",
        h1: "Fensterreinigung Innsbruck – streifenfrei, innen & außen",
        short: "Streifenfreie Klarheit – innen wie außen.",
        intro:
            "Klare Fenster bringen mehr Licht, mehr Atmosphäre und einen besseren Eindruck – im Büro genauso wie zu Hause. Wir reinigen Fenster in Innsbruck und Tirol streifenfrei, inklusive Rahmen, Fensterbänken und Rollläden, auch in der Höhe.",
        details: [
            "Privat & Gewerbe",
            "Inkl. Rahmen, Fensterbänke, Rolläden",
            "Auch in Höhe mit Teleskoptechnik",
        ],
        bullets: [
            "Wohnungen, Häuser und Wintergärten",
            "Glasfassaden, Schaufenster und Eingangsbereiche",
            "Mit Teleskopstange bis zu 20 m – ohne aufwendiges Gerüst",
            "Regelmäßige Termine möglich (saisonal/quartalsweise)",
        ],
        seo_title:
            "Fensterreinigung Innsbruck – streifenfrei, Privat & Gewerbe",
        seo_description:
            "Streifenfreie Fensterreinigung in Innsbruck und Tirol für Privat und Gewerbe. Inkl. Rahmen, Fensterbänke, Rolläden – auch in der Höhe. ☎ +43 676 7092658.",
        keywords: [
            "Fensterreinigung Innsbruck",
            "Fensterputzer Innsbruck",
            "Fensterreinigung Tirol",
            "Glasreinigung Innsbruck",
        ],
        icon: "PanelsTopLeft",
        image:
            "https://images.pexels.com/photos/6196678/pexels-photo-6196678.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=720&w=1100",
    },
    {
        slug: "unterhaltsreinigung",
        title: "Unterhaltsreinigung",
        h1: "Unterhaltsreinigung Innsbruck – regelmäßig & zuverlässig",
        short: "Regelmäßig, diskret und planbar nach Ihrem Rhythmus.",
        intro:
            "Eine konsequent saubere Umgebung wirkt – auf Mitarbeiter, auf Bewohner, auf Gäste. Mit unserer Unterhaltsreinigung bekommen Sie planbare Qualität: fester Rhythmus, fixe Ansprechperson und transparente Dokumentation.",
        details: [
            "Täglich, wöchentlich, monatlich",
            "Fixe Ansprechperson",
            "Saubere Dokumentation",
        ],
        bullets: [
            "Reinigungspläne nach Ihren Anforderungen",
            "Tagesreinigung möglich – diskret und unauffällig",
            "Bürohäuser, Praxen, Schulen, Hausverwaltungen",
            "Inkl. Verbrauchsmaterial-Management auf Wunsch",
        ],
        seo_title:
            "Unterhaltsreinigung Innsbruck – Büro- und Hausreinigung",
        seo_description:
            "Regelmäßige Unterhaltsreinigung in Innsbruck und Tirol für Büros, Praxen, Hausverwaltungen und Privat. Fixe Ansprechperson und planbare Qualität. ☎ +43 676 7092658.",
        keywords: [
            "Unterhaltsreinigung Innsbruck",
            "Büroreinigung Innsbruck",
            "Praxisreinigung Innsbruck",
            "Hausreinigung Innsbruck",
        ],
        icon: "Sparkles",
        image:
            "https://images.pexels.com/photos/4239031/pexels-photo-4239031.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=720&w=1100",
    },
    {
        slug: "spezialreinigung",
        title: "Spezialreinigung",
        h1: "Spezialreinigung Tirol – Bauend, Photovoltaik & mehr",
        short: "Für alles, was über Standard hinausgeht.",
        intro:
            "Manche Aufträge brauchen mehr als die klassische Reinigung – Bauendreinigung nach Sanierung, Photovoltaik-Reinigung für mehr Ertrag oder Spezialflächen wie Teppiche und Polster. Wir bringen das passende Equipment und die nötige Erfahrung.",
        details: [
            "Bauend- und Grundreinigung",
            "Photovoltaik-Anlagen",
            "Teppich-, Polster- & Sonderflächen",
        ],
        bullets: [
            "Bauendreinigung nach Neubau, Umbau oder Sanierung",
            "Photovoltaik-Reinigung für maximale Stromerträge",
            "Teppich- und Polsterreinigung mit Tiefenwirkung",
            "Industrie- und Werkstattreinigung auf Anfrage",
        ],
        seo_title:
            "Spezialreinigung Tirol – Bauendreinigung, Photovoltaik, Teppich",
        seo_description:
            "Spezialreinigung in Innsbruck und Tirol: Bauendreinigung, Photovoltaik-Reinigung, Teppich- und Polsterreinigung. Mit Profi-Equipment. ☎ +43 676 7092658.",
        keywords: [
            "Spezialreinigung Tirol",
            "Bauendreinigung Innsbruck",
            "Photovoltaik Reinigung Tirol",
            "Teppichreinigung Innsbruck",
        ],
        icon: "Wrench",
        image:
            "https://images.pexels.com/photos/4108720/pexels-photo-4108720.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=720&w=1100",
    },
    {
        slug: "hausmeisterservice",
        title: "Hausmeisterservice",
        h1: "Hausmeisterservice Innsbruck – das ganze Jahr verlässlich",
        short: "Winterdienst, Gartenpflege, kleine Reparaturen – alles aus einer Hand.",
        intro:
            "Ein guter Hausmeister hält ein Objekt im Hintergrund am Laufen – sichtbar nur, wenn etwas fehlen würde. Unser Hausmeisterservice in Innsbruck und Tirol kümmert sich ganzjährig um Ihr Gebäude: Schneeräumung und Streudienst im Winter, Gartenpflege im Sommer, dazwischen Kontrollgänge, Müllraum-Pflege und kleine Reparaturen.",
        details: [
            "Winterdienst: Schneeräumung & Streuen",
            "Gartenpflege: Rasen mähen, Hecken schneiden, Laub räumen",
            "Müllraum- und Außenbereich-Pflege",
            "Kontrollgänge, Lampenwechsel, Kleinreparaturen",
        ],
        bullets: [
            "Räum- und Streupflicht zuverlässig erfüllt (24/7 Bereitschaft im Winter)",
            "Saisonale Gartenpflege – Rasen, Hecken, Sträucher, Laub",
            "Pflege von Müllräumen, Containerplätzen und Eingangsbereichen",
            "Kontrollgänge mit Mängel-Dokumentation für die Hausverwaltung",
            "Kleinreparaturen (Glühlampen, Türschließer, einfache Schäden)",
            "Notdienst- und Schlüsselservice nach Vereinbarung",
        ],
        seo_title:
            "Hausmeisterservice Innsbruck & Tirol – Winterdienst, Gartenpflege",
        seo_description:
            "Hausmeisterservice in Innsbruck und Tirol: Winterdienst, Schneeräumung, Gartenpflege, Müllraum, Kontrollgänge und Kleinreparaturen. Verlässlich für Hausverwaltungen und Privat. ☎ +43 676 7092658.",
        keywords: [
            "Hausmeisterservice Innsbruck",
            "Hausmeister Tirol",
            "Winterdienst Innsbruck",
            "Schneeräumung Tirol",
            "Gartenpflege Innsbruck",
        ],
        icon: "HardHat",
        image:
            "https://images.pexels.com/photos/19015148/pexels-photo-19015148.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=720&w=1100",
    },
    {
        slug: "entruempelung",
        title: "Entrümpelung",
        h1: "Entrümpelung Innsbruck – Wohnung, Keller & Haushaltsauflösung",
        short: "Wohnungs-, Keller- und Nachlassräumung inkl. fachgerechter Entsorgung.",
        intro:
            "Eine Entrümpelung ist oft eine emotionale und logistische Herausforderung – wir nehmen Ihnen beides ab. Vom einzelnen Kellerabteil bis zur kompletten Haushaltsauflösung in Innsbruck und Tirol: besenrein, diskret, fair kalkuliert und mit fachgerechter Entsorgung.",
        details: [
            "Wohnungs- und Hausräumung",
            "Keller-, Dachboden- und Garagenräumung",
            "Haushaltsauflösung & Nachlassräumung",
            "Geschäfts- und Büroräumung",
        ],
        bullets: [
            "Kompletträumung – besenrein übergeben",
            "Haushaltsauflösung mit Anrechnung verwertbarer Gegenstände",
            "Diskrete Nachlassräumung mit Pietät",
            "Messi-Wohnungen, schwierige Räumungen mit Sondergeräten",
            "Sperrmüll, Elektroschrott, Sondermüll – alles fachgerecht entsorgt",
            "Auf Wunsch inkl. Endreinigung (Bauend-/Grundreinigung)",
        ],
        seo_title:
            "Entrümpelung Innsbruck & Tirol – Wohnung, Keller, Haushaltsauflösung",
        seo_description:
            "Entrümpelung in Innsbruck und Tirol: Wohnungsräumung, Kellerräumung, Haushaltsauflösung, Nachlassräumung und Geschäftsräumung – besenrein, diskret und fair. ☎ +43 676 7092658.",
        keywords: [
            "Entrümpelung Innsbruck",
            "Entrümpelung Tirol",
            "Wohnungsräumung Innsbruck",
            "Haushaltsauflösung Innsbruck",
            "Kellerräumung Innsbruck",
            "Nachlassräumung Tirol",
        ],
        icon: "Truck",
        image:
            "https://images.pexels.com/photos/4246109/pexels-photo-4246109.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=720&w=1100",
    },
];

export const SERVICE_OPTIONS = [
    "Gebäudereinigung",
    "Fassadenreinigung",
    "Fensterreinigung",
    "Unterhaltsreinigung",
    "Spezialreinigung",
    "Hausmeisterservice",
    "Entrümpelung",
    "Sonstiges",
];
